import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { FormsModule } from '@angular/forms';
import { StepsModule } from 'primeng/steps';
import { ListboxModule } from 'primeng/listbox';
import { BadgeComponent } from './badge/badge.component';
import { StepsComponent } from './steps/steps.component';
import { RadioButtonModule } from 'primeng/radiobutton';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { CheckboxModule } from 'primeng/checkbox';
import { SplitButtonModule } from 'primeng/splitbutton';
import { TabViewModule } from 'primeng/tabview';
import { ApproveRejectComponent } from './approve-reject/approve-reject.component';
import { DialogModule } from 'primeng/dialog';
import { RippleModule } from 'primeng/ripple';
import { ChartModule } from 'primeng/chart';

@NgModule({
  declarations: [BadgeComponent, StepsComponent, ApproveRejectComponent],
  imports: [
    CommonModule,
    ButtonModule,
    CheckboxModule,
    DropdownModule,
    FormsModule,
    InputTextareaModule,
    InputTextModule,
    ListboxModule,
    SplitButtonModule,
    StepsModule,
    RadioButtonModule,
    TabViewModule,
    DialogModule,
    RippleModule,
    ChartModule,
  ],
  exports: [
    CommonModule,
    BadgeComponent,
    FormsModule,
    RadioButtonModule,
    ApproveRejectComponent,
  ],
})
export class ComponentModule {
  // TODO
}
